export default __webpack_public_path__ + "static/media/brasil.7d9ff8b4.svg";